import { AxiosResponse } from 'axios';
import { sendPut } from './dataUtilities';
import env from '../env';
import { ResponseError, Headers } from './dataTypes';

const PUT_AVATAR = '/social/users/self/avatar';

export const putAvatar = (avatar: File): Promise<AxiosResponse<any> | ResponseError> => {
  const formData = new FormData();
  formData.append('file', avatar);
  const headers: Headers = {};
  headers['Content-Type'] = 'multipart/form-data';
  headers['FFF-Auth'] = 'V1.1';
  return sendPut(
    `${env.hermesUrl + PUT_AVATAR}`, formData, { headers },
  );
};

export default putAvatar;
